import { useCallback } from 'react';
import useReportGenerate, { ReportCallback } from '@/hooks/useReportGenerate';
import { FileType } from '@/hooks/useFileLoading';

interface ReportHandlersHook {
  handleView: () => Promise<void>;
  handlePdf: () => Promise<void>;
  handleCsv: () => Promise<void>;
}

export const useReportHandlers = (
  fileName: string,
  callback: (format: FileType, callback?: ReportCallback) => Promise<void>,
): ReportHandlersHook => {
  const report = useReportGenerate();

  const handleView = useCallback(async () => {
    await callback('REPORT_VIEW', (result) =>
      report.openFile({
        result,
        fileName: fileName,
        fileType: 'application/pdf',
      }),
    );
  }, [callback, fileName, report]);

  const handlePdf = useCallback(async () => {
    await callback('PDF', (result) =>
      report.downloadFile({ result, fileName: `${fileName}.pdf` }),
    );
  }, [callback, fileName, report]);

  const handleCsv = useCallback(async () => {
    await callback('CSV', (result) =>
      report.downloadFile({ result, fileName: `${fileName}.csv` }),
    );
  }, [callback, fileName, report]);

  return {
    handleView,
    handlePdf,
    handleCsv,
  };
};
